import './ClientDataCardSkeleton.scss';

const SKELETON_ROWS = 3;

const ClientDataCardSkeleton = () => (
  <div className="client-data-card-skeleton" aria-hidden="true">
    {Array.from({ length: SKELETON_ROWS }, (_, index) => (
      <div key={index} className="client-data-card-skeleton__row">
        <span className="client-data-card-skeleton__bar client-data-card-skeleton__bar--label" />
        <span className="client-data-card-skeleton__bar client-data-card-skeleton__bar--value" />
      </div>
    ))}
  </div>
);

export default ClientDataCardSkeleton;
